import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader, CardText } from 'material-ui/Card';

import CPDIcon from 'material-ui/svg-icons/toggle/star';

import SkillStat from '../Skill/SkillStat';
import CPD from '../Display/CPD';

const CpdSegment = ({cpdCredits, skillId, passMark}) => {

    let subtitle = '';
    let content = null;
    let contentData = [];

    let iconProps = {
        color: 'rgba(117, 117, 117 ,0.7)',
    };

    let avatarIcon = (<CPDIcon {...iconProps}/>);

    if (!!cpdCredits && cpdCredits > 0) {
            contentData.push(
                <CardText key="cpd" className="cent-card-text">
                    <CPD amount={cpdCredits} format="pts"/>
                </CardText>
            );
    }

    if (!!skillId) {
        contentData.push(
            <CardText key="SkillStat" className="cent-card-text">
                <SkillStat skillId={skillId}/>
            </CardText>
        );
    }

    if (contentData.length > 0) {
        content = (
            <Card className='cent-card' key='cpdSegment'>
                <CardHeader
                    title='CPD'
                    subtitle={subtitle}
                    avatar={avatarIcon}
                />
                {contentData}
            </Card>
        );
    }

    return content;
};

CpdSegment.propTypes = {
    cpdCredits:    PropTypes.number,
    skillId:       PropTypes.number,
    passMark:      PropTypes.number,
};

export default CpdSegment;
